/**
 * @generated SignedSource<<1ad7a0ea396dd298aad11651538ce0cd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductInternalTools_itemSearch" | "QuickView_itemSearch">;
  readonly " $fragmentType": "ProductBaseTile_itemSearch";
};
export type ProductBaseTile_itemSearch$key = {
  readonly " $data"?: ProductBaseTile_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickView_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductInternalTools_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e0c7e762630c566cada8b51f318abb6c";

export default node;
